<boi-contextual-help-container
  [ngClass]="{ 'has-errors': hasError }"
  [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName"
>
  <boi-validation-error (errorChange)="hasError = $event" [propertyNames]="propertyNames"></boi-validation-error>

  <kendo-textbox-container class="form-element app">
    <div class="form-label app" [boiRequiredFormField]="labelName" [forceNotRequired]="forceNotRequired">
      <label [innerHtml]="labelName | localizeLabel"></label>
    </div>

    <div class="form-input-container">
      <label *ngFor="let option of optionList | localizeOptionList">
        <input
          [attr.name]="controlId ? controlId : labelName"
          [name]="controlId ? controlId : labelName"
          type="radio"
          class="k-radio"
          [(ngModel)]="value"
          [disabled]="isFieldDisabled || isReadonly"
          (ngModelChange)="valueChange.emit(value)"
          [value]="option.Code"
        />
        <span class="k-radio-label">{{ option.Value }}</span>
      </label>
    </div>

    <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
  </kendo-textbox-container>
</boi-contextual-help-container>
